module.exports = __webpack_public_path__ + "static/media/W5390484_38.b4cea70a.jpg";